import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';
import { Button } from 'reactstrap';

class ErrorBoundary extends Component {
  state = { eventId: null };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch( error, errorInfo ) {
    Sentry.withScope( ( scope ) => {
      scope.setExtras( errorInfo );
      const eventId = Sentry.captureException( error );
      this.setState( { eventId } );
    } );
  }

  render() {
    const { hasError, eventId } = this.state;
    const { children } = this.props;
    return hasError ? (
      <div className="text-center mt-5">
        <h1>Ops, there was an error!</h1>
        <Button color="primary" onClick={() => Sentry.showReportDialog( { eventId } )}>
          Report feedback
        </Button>
      </div>
    ) : children;
  }
}

export default ErrorBoundary;
